import { FC, ChangeEvent } from "react";
import { useController, useFormContext, useFormState } from "react-hook-form";

interface Props {}

const GradingQuestion: FC<Props> = () => {
	const { control } = useFormContext<GradingFormState>();
	const { errors } = useFormState({ control });
	const rules = { required: "Please enter an answer" };

	const { field: gradePerformance } = useController({
		name: "gradePerformance",
		control,
		rules
	});

	const { field: gradingComments } = useController({
		name: "gradingComments",
		control,
		rules
	});

	const handleSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
		gradePerformance.onChange(event);
	};

	const handleTextChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
		gradingComments.onChange(event);
	};

	const gradePerformanceOptions: IGreatConversationGradePerformance[] = [
		"Great",
		"Good",
		"Needs development",
		"Unsatisfactory"
	];

	return (
		<>
			<div
				className={[
					"relative bg-muted rounded-lg border",
					errors.gradePerformance ? "border-destructive" : "border-transparent"
				].join(" ")}
				aria-label="gradePerformance"
			>
				{errors.gradePerformance && (
					<div className="relative">
						<span className="absolute top-[-12px] right-3 bg-destructive text-white text-xs px-2 py-0.5 rounded">
							{errors.gradePerformance.message}
						</span>
					</div>
				)}

				<div className="p-4">
					<div className="flex items-start gap-2">
						<div className="flex-1">
							<label
								className="block font-bold mb-1 text-xl"
								htmlFor="gradePerformance"
							>
								Grade Performance
							</label>

							<select
								id="gradePerformance"
								className="w-full mt-4 px-3 py-2 bg-white border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring"
								role="combobox"
								{...gradePerformance}
								onChange={(e) => handleSelectChange(e)}
								defaultValue=""
							>
								<option disabled value="">
									Please select
								</option>

								{gradePerformanceOptions.map((answer) => (
									<option value={answer} key={answer}>
										{answer}
									</option>
								))}
							</select>
						</div>
					</div>
				</div>
			</div>

			<div
				className={[
					"relative bg-muted rounded-lg border",
					errors.gradingComments ? "border-destructive" : "border-transparent"
				].join(" ")}
				aria-label="gradingComments"
			>
				{errors.gradingComments && (
					<div className="relative">
						<span className="absolute top-[-12px] right-3 bg-destructive text-white text-xs px-2 py-0.5 rounded">
							{errors.gradingComments.message}
						</span>
					</div>
				)}

				<div className="p-4">
					<div className="flex items-start gap-2">
						<div className="flex-1">
							<label
								className="block font-bold mb-1 text-xl"
								htmlFor="gradingComments"
							>
								Grading comments
							</label>

							<textarea
								id="gradingComments"
								placeholder="Please enter your comments"
								className="w-full mt-4 px-3 py-2 bg-white border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring resize-none min-h-[100px]"
								{...gradingComments}
								onChange={(e) => handleTextChange(e)}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default GradingQuestion;
